import React, { Component } from "react";
import { PrimaryButton } from "../../components/BasicForm";
import { VisitorRelationshipForm } from "../../components/VisitorRelationshipForm";
class VisitorOffenderRelationship extends Component {
  state = {
    heading: "Your Relationship to Inmate",
    showProgressBar: true,
    pageId: "relationship-to-offender",
    nonImmediateFamily: 0
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step
    );
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  handleInputChange = e => {
    this.props.handleInputChange(e);
    // this.countNonImmediateFam();
  };
  countNonImmediateFam() {
    const selectedOffenders = this.props.fields.selectedOffenders;
    let nonImmediateFamily = 0;
    Object.keys(selectedOffenders).map(offenderId => {
      const offender = selectedOffenders[offenderId];
      if (!offender.RelationshipToVisitor.immediateFamily) {
        nonImmediateFamily += 1;
      }
      return offender;
    });
    return nonImmediateFamily;
  }
  handleRemoveOffender = offenderId => {
    const selectedOffenders = this.props.fields.selectedOffenders;
    let affirmative = window.confirm(
      "Are you sure you want to remove the selected inmate?"
    );
    if (affirmative) {
      this.props.removeSelectedOffender(offenderId);
    }
    if (Object.keys(selectedOffenders).length < 1) {
      this.handlePrevious();
    }
  };
  handlePrevious = () => {
    const stepData = this.props.stepData;
    this.props.previousStep(stepData);
  };
  handleSubmit = () => {
    const isErr = this.props.validateRelationshipFields();
    const stepData = this.props.stepData;
    const nonImmediateFamily = this.countNonImmediateFam();

    if (!isErr && !(nonImmediateFamily > 1)) {
      this.props.nextStep(stepData);
    } else {
      this.scrollToError();
    }
  };
  scrollToError = () => {
    const fields = this.props.fields;
    const selectedOffenders = fields.selectedOffenders;
    const relationshipTypeErr = document.getElementById(
      "non-immediate-family-err"
    );
    let errFields = [];
    Object.keys(selectedOffenders).map(offenderId => {
      if (
        selectedOffenders[offenderId].RelationshipToVisitor.className ===
        "input-err"
      ) {
        errFields.push(offenderId);
      }
      return offenderId;
    });
    const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
    if (relationshipTypeErr) {
      relationshipTypeErr.scrollIntoView();
    } else if (firstErr) {
      firstErr.scrollIntoView();
    }
  };
  render() {
    const fields = this.props.fields;
    const selectedOffenders = fields.selectedOffenders;
    const nonImmediateFamily = this.countNonImmediateFam();
    return (
      <div className="col-14">
        <p className="description">
          Select your relationship to the inmate listed below.
        </p>
        <form className="visitation-form clear-fix" id="relationship">
          {nonImmediateFamily > 1 ? (
            <div id="non-immediate-family-err" className="disclaimer-container">
              <p className="disclaimer body-bold">
                <img
                  src="/images/icons/declined.svg"
                  aria-hidden="true"
                  alt="Exclamation point icon"
                />
                <span>
                  According to Operating Procedure 851.1, each person is limited
                  to visiting one non-immediate family member. This includes
                  your aunt, uncle, cousin, in-law, and friend. Please remove
                  additional non-immediate family members from your application.
                </span>
              </p>
            </div>
          ) : (
            false
          )}
          <ul>
            {Object.keys(selectedOffenders).map(offenderId => (
              <li key={offenderId}>
                <VisitorRelationshipForm
                  id={offenderId}
                  handleRemoveOffender={this.handleRemoveOffender}
                  className={
                    selectedOffenders[offenderId].RelationshipToVisitor
                      .className
                  }
                  fullName={selectedOffenders[offenderId].FullName}
                  value={
                    selectedOffenders[offenderId].RelationshipToVisitor.value
                  }
                  handleInputChange={this.handleInputChange}
                  errMessage={
                    selectedOffenders[offenderId].RelationshipToVisitor
                      .errMessage
                  }
                />
              </li>
            ))}
          </ul>
          <PrimaryButton
            className="primary-button"
            handleClick={this.handleSubmit}
            label="Submit"
            options={Object.keys(fields)}
          />
        </form>
      </div>
    );
  }
}

export default VisitorOffenderRelationship;



// WEBPACK FOOTER //
// ./src/pages/VisitorOffenderRelationship/VisitorOffenderRelationship.js